<template>
	<v-app>
		<div class="initialView">
			<div class="initialViewContent">
				<div class="logo">
					<img src="@/assets/robot.png" alt="">
				</div>
				<div class="loginForm">
					<div class="loginFormTitle">
						<h2>Oturum Aç</h2>
					</div>

					<div class="formField">
						<input type="text" name="username" autocomplete="off" autocorrect="off" autocapitalize="off"
							spellcheck="false" v-model="username" :class="{'filled' : username != ''}"
							v-on:keyup.enter="onPressEnterUsername()" ref="formUsername" autofocus>
						<span class="fieldLabel">Kullanıcı Adı</span>
					</div>
					<div class="formField">
						<input type="password" name="password" v-model="password" :class="{'filled' : password != ''}"
							v-on:keyup.enter="onPressEnterPassword()" ref="formPassword">
						<span class="fieldLabel">Parola</span>
					</div>
					<div class="formAction">
						<v-btn depressed large color="#1a73e8" :disabled="!isFormValid" :loading="isLoading"
							@click="login()">Giriş Yap</v-btn>
					</div>

				</div>
			</div>

		</div>

		<v-snackbar v-model="snackbar.show" color="error" :timeout="snackbar.timeout" top>
			{{ snackbar.text }}
		</v-snackbar>

	</v-app>
</template>

<script>
	export default {
		name: 'ControllerLogin',
		components: {},
		data: () => ({
			username: "",
			password: "",
			isLoading: false,
			snackbar: {
				show: false,
				text: "Kullanıcı adı veya şifre hatalı",
				timeout: 3000
			}
		}),
		watch: {
			username(n, o) {
				if (n.toLowerCase() != o) {
					this.username = n.toLowerCase()
				}
			}
		},
		mounted() {
			this.isLoading = false;
		},
		methods: {
			login() {
				if (!this.isLoading && this.isFormValid) {
					this.isLoading = true;
					this.$http.post(process.env.VUE_APP_API_URL + "/auth/login", {
						username: this.username,
						password: this.password,
					}, {
						params: {}
					}).then(response => { 
						if( response.body.isLogged ){
							this.$emit("checkLogin",true)
						}
						else{
							this.isLoading = false;
							this.snackbar.show = true;
						}
					})
				}
			},
			onPressEnterUsername() {
				this.$refs.formPassword.focus();
			},
			onPressEnterPassword() {
				this.$refs.formPassword.blur();
				this.login()
			}
		},
		computed: {
			isFormValid() {
				if (this.username != "" && this.password != "") {
					return true;
				}
				return false;
			}
		}
	}
</script>

<style lang="less">
	.initialView {
		width: 450px;
		height: 450px;
		border: 1px solid #dadce0;
		border-radius: 8px;
		display: block;
		margin: 0 auto;
		margin-top: 44px;
		background: #fff;
		max-width: 100%;

		@media(max-width:500px) {
			border: none;
			margin: 0px;
		}

		.initialViewContent {
			padding: 30px 40px 36px 40px;

			@media(max-width:500px) {
				// padding: 30px 20px 36px 20px;
			}

			.logo {
				text-align: center;

				img {
					height: 80px;

					@media(max-width:500px) {
						height: 50px;
					}
				}
			}

			.loginFormTitle {
				margin-bottom: 30px;
			}

			.loginForm {
				h2 {
					text-align: center;
					font-weight: 500
				}

				.formField {
					display: block;
					position: relative;
					margin-bottom: 25px;

					@media(max-width:500px) {
						margin-bottom: 15px;
					}

					height:54px;

					input {
						display: block;
						width: calc(~"100% - 2px");
						width: 100%;
						border-radius: 4px;
						color: #202124;
						font-size: 16px;
						height: 28px;
						height: auto;
						margin: 2px 0px;
						padding: 13px 15px;
						z-index: 1;
						border: 2px solid #ccc;
						box-sizing: content-box;
						box-sizing: border-box;
						outline: none;
						transition: all .2s;
						background-color: #fff !important;

						&:focus,
						&.filled {
							// width: calc(~"100% - 4px");
							// width: 100%;
							border: 2px solid #1a73e8;
							margin: 0px 0px;
						}
					}

					input:-webkit-autofill,
					input:-webkit-autofill:hover,
					input:-webkit-autofill:focus,
					input:-webkit-autofill:active {
						-webkit-box-shadow: 0 0 0 30px white inset !important;
					}

					.fieldLabel {
						position: absolute;
						left: 7px;
						top: 50%;
						background-color: #fff;
						padding: 0px 8px;
						transform: translateY(-50%);
						pointer-events: none;
						font-size: 16px;
						transition: all .2s;
						font-weight: 400;
						color: #80868b;
					}

					input:focus+.fieldLabel,
					input.filled+.fieldLabel {
						transform: scale(.75) translateY(-50%) translateX(-3px);
						top: 0px;
						left: 0px;
						color: #1a73e8
					}
				}

				.formAction {
					.v-btn {
						display: block;
						width: 100%;
						margin: 0px;
						color: #fff;

						.v-btn__content {
							text-transform: none;
						}
					}
				}
			}
		}
	}
</style>